/** Official mymech lockup from International Brand Guidelines v1.1. */
export function BrandLogo({ compact = false, tagline = false, className = "" }) {
  if (tagline && !compact) {
    return (
      <img
        src="/brand/logo-primary.png"
        alt="mymech - The mechanic you can trust"
        className={`w-auto object-contain object-left ${className || "h-14 max-w-[240px]"}`}
      />
    );
  }

  return (
    <img
      src="/brand/logo-nav.png"
      alt="mymech"
      className={`w-auto object-contain object-left ${className || "h-8 max-w-[168px]"}`}
    />
  );
}

export default BrandLogo;
